<template>
  <div class="navbar">
    <nav class="nav">
      <p class="nav--link" v-if="isPharmacist">
        Credits:
        <span class="nav--highlight">{{
          $store.getters.userInfo.credits
        }}</span>
      </p>
      <p class="nav--spacer" v-else />
      <div class="nav--container">
        <ToggledCheckbox
          v-if="isPharmacist"
          class="admin__access"
          :checked="isAdminAccess"
          @toggled-checkbox-change="handleAdminAccessChange"
          label="Laisser l'admin accéder à mon compte"
        />
        <router-link class="nav--link" to="/tutorial">TUTORIEL</router-link>
        <base-button
          :fluid="false"
          type="hollowed"
          style="padding: 12px 24px;"
          @click.native="logout"
          >Logout</base-button
        >
      </div>
    </nav>
  </div>
</template>

<script>
import { toggleAdminAccess } from "@/api/users"
import ToggledCheckbox from "@/components/ToggledCheckbox"
import { Message } from "element-ui"
export default {
  components: {
    ToggledCheckbox
  },
  computed: {
    isPharmacist() {
      return this.$store.getters.roles.includes("pharmacist")
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch("logOut")
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      this.$router.push("/login")
    },
    async handleAdminAccessChange() {
      try {
        await toggleAdminAccess(this.$store.getters.userInfo.id)
        Message.success("L'accès admin a été mis à jour")
      } catch {
        Message.error("L'accès admin n'a pas été modifié.")
      }
    }
  },
  created() {
    if (this.$store.getters.userInfo.admin_access !== 0) {
      this.isAdminAccess = true
    }
  },
  data: () => ({
    isAdminAccess: false
  })
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.admin__access {
  flex-flow: row-reverse nowrap !important;
  .checkbox {
    &__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
    }
    &__label {
      max-width: unset !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.navbar {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  padding: 0 20px;
  .nav {
    height: 50px;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    &--container {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &--highlight {
      color: $color-secondary--dark;
      font-size: 1.1rem;
    }
    &--link {
      text-transform: uppercase;
      margin: 0 15px;
      font-weight: 800;
      font-size: 13px;
      color: $color-accent;
      transition: color 0.3s;
      &:hover {
        color: $color-primary--light;
      }
    }
  }
}
</style>
